import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export type NurseIconProps = SvgIconProps

export function NurseIcon(props: NurseIconProps) {
  const { htmlColor } = props
  return (
    <SvgIcon
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 200 200"
      xmlSpace="preserve"
      {...props}
    >
      <g id="Nurse_or_care_staff">
        <g>
          <g id="XMLID_00000137852913440299573440000009355927948908975754_">
            <g>
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M65.613,186.597h-20.1v-41.05c0-16.24,12.49-29.94,29.12-33.64c7.19,5.6,15.93,8.87,25.37,8.87
					c9.43,0,18.17-3.27,25.41-8.87c16.63,3.7,29.07,17.4,29.07,33.64v38.03v3.02h-18.3H65.613z"
              />
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M130.123,13.407c3.65,0,6.47,3.21,6.01,6.84l-3.35,25.91c-0.04,0.35-0.24,0.65-0.52,0.82
					c-0.18,0.12-0.4,0.19-0.63,0.19h-63.27c-0.28,0-0.54-0.1-0.74-0.28c-0.22-0.17-0.37-0.43-0.41-0.73l-3.34-25.91
					c-0.47-3.63,2.35-6.84,6.01-6.84H130.123z"
              />
            </g>
            <g>
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M136.183,186.597h18.3
					v-3.02v-38.03c0-16.24-12.44-29.94-29.07-33.64c-7.24,5.6-15.98,8.87-25.41,8.87c-9.44,0-18.18-3.27-25.37-8.87
					c-16.63,3.7-29.12,17.4-29.12,33.64v41.05h20.1H136.183z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M132.263,46.977
					c-0.18,0.12-0.4,0.19-0.63,0.19h-63.27c-0.28,0-0.54-0.1-0.74-0.28c-0.22-0.17-0.37-0.43-0.41-0.73l-3.34-25.91
					c-0.47-3.63,2.35-6.84,6.01-6.84h60.24c3.65,0,6.47,3.21,6.01,6.84l-3.35,25.91C132.743,46.507,132.543,46.807,132.263,46.977z"
              />
              <polyline
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="88.063,29.637 
					100.003,29.637 111.943,29.637 				"
              />
              <polyline
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="100.003,41.577 
					100.003,29.637 100.003,17.697 				"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M69.283,75.687
					c-0.51-2.61-5.39-1.49-6.87-7.62c-2.16-8.99,3.72-10.48,6.26-8.7"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M130.463,75.687
					c0.51-2.61,5.66-1.49,7.14-7.62c2.16-8.99-3.99-10.48-6.53-8.7"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M132.263,46.977
					c0.33,4.22-0.52,8.5-2.34,12.38c-0.23,0.48-0.47,0.95-0.72,1.41l-0.01,0.01c-0.89-1.91-1.79-3.39-2.69-5.12
					c-0.41-0.8-1.29-1.21-2.16-1.02c-12.1,2.65-21.13,4.41-27.41,2.56c-8.87-2.62-15.25-7.34-20.38-4.39
					c-1.82,1.05-3.04,2.81-3.86,4.8c-0.82,1.98-0.68,1.72-1.47,3.17c-0.3-0.47-0.58-0.95-0.84-1.44c-2.06-3.82-3.02-8.15-2.76-12.45
					"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M69.293,75.687
					c2.87,19.06,15.47,33.41,30.58,33.41c15.12,0,27.72-14.35,30.59-33.41"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="65.613"
                y1="148.087"
                x2="65.613"
                y2="186.597"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="136.183"
                y1="148.087"
                x2="136.183"
                y2="186.597"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Layer_1"></g>
    </SvgIcon>
  )
}

export default NurseIcon
